import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CameraOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.71 6.68h-1.28l-.37-1.04c-.34-.97-1.29-1.63-2.36-1.63H9.28c-1.07 0-2.02.66-2.36 1.63l-.37 1.04h-.97c-1.71 0-3.09 1.38-3.09 3.09v7.22c0 1.71 1.38 3.09 3.09 3.09h13.13c1.7 0 3.09-1.38 3.09-3.09V9.77c0-1.71-1.39-3.09-3.09-3.09Zm-2.52 1.6h2.52c.82 0 1.49.67 1.49 1.49v7.22c0 .83-.67 1.49-1.49 1.49H5.58c-.82 0-1.49-.66-1.49-1.49V9.77c0-.82.67-1.49 1.49-1.49h2.27l.4-1.6.18-.51c.11-.33.46-.56.85-.56h5.42c.39 0 .74.23.86.56l.18.51.45 1.6Z" />
      <Path d="M11.97 17.49c-2.41 0-4.37-1.96-4.37-4.37s1.96-4.37 4.37-4.37 4.37 1.96 4.37 4.37-1.96 4.37-4.37 4.37Zm0-7.13a2.77 2.77 0 1 0 0 5.54 2.77 2.77 0 0 0 0-5.54ZM18.59 10.51h-1.18c-.44 0-.8-.36-.8-.8 0-.44.36-.8.8-.8h1.18c.44 0 .8.36.8.8 0 .44-.36.8-.8.8Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CameraOutlined
